<template>

  <div class="p-list-representation-record-modal-content w-100 row">
    <form id="signup-form" class="row w-100" v-on:submit.prevent="submit">

      <div :class="{ 'p-list-representation-error': $v.formData.full_name.$error }" class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label  class="ml-4 p-list-representation-label-text mb-2 mb-lg-0 p-edit-representation-form-text">
          نام و نام خانوادگی صاحب
        </label>
        <input v-model="formData.full_name" type="text" placeholder="" class="form-control text-right col-lg-8 pr-3 pl-2 pr-2">
      </div>

      <div :class="{ 'p-list-representation-error': $v.formData.mobile.$error }"  class="d-flex align-items-center mb-4 align-items-center p-edit-representation-form-item" >
        <label   class="ml-4 p-list-representation-label-text mb-lg-0 mb-2 p-edit-representation-form-text">
           موبایل صاحب
        </label>
        <input v-model="formData.mobile" type="text" placeholder="" class="form-control text-right col-lg-9 pr-3 pl-2 pr-2">
      </div>

      <div class="flex-column justify-content-center w-100 p-list-salon-owner-export-btns d-flex flex-lg-row mb-4 mt-2">
              <button type="submit" class="p-list-representation-btn btn btn-primary btn-sm mb-lg-0 mb-3">
                جستجو
              </button>

            <button type="button" class="p-list-representation-btn btn btn-primary btn-sm mr-0 mr-lg-4  mr-0 mb-lg-0 mb-3">
              خروجی اکسل بانک
            </button>

            <button  type="button" class="p-list-representation-btn btn btn-primary btn-sm  mr-0 mr-lg-4 ">
              خروجی اکسل برای بانک
            </button>
      </div>

      <div class="w-100 row justify-content-center">
        <button @click="switchPageRepresentative" type="click" class="btn btn-primary btn-blue col-lg-2">ثبت سالندار</button>
      </div>

    </form>
  </div>

</template>

<script>
import { required, minLength, between, numeric } from 'vuelidate/lib/validators'

const checkTypeValueAndLenValue = (value, countCheckValue) => {
  const checkTypeValue = /^\d+$/.test(value)

  if (checkTypeValue) {
    if (value.length == countCheckValue) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export default {
  name: 'formEditRepresentation',
  props: {
    formDataOriginal: { type: Object, default: {} }
  },

  data () {
    return {
      formData: {

      }

    }
  },

  validations: {
    formData: {
      full_name: {

      },
      mobile: {
        currentFunc (value) {
          if (typeof (value) !== 'undefined' && value != '') {
            return /^09[0-9]{9}$/.test(value)
          } else {
            return true
          }
        }
      }

    }

  },

  computed: {

  },

  mounted () {
  },

  watch: {
    formDataOriginal (data) {
      this.formData = data
    }
  },

  methods: {
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$message.error('لطفا اطلاعات خود را بررسی کنید')
      } else {
        this.$emit('searchData', this.formData)
      }
    },

    switchPageRepresentative () {
      this.$router.push({ name: 'entryListSalonOwner' })
    }

  }

}
</script>
